export const SET_GC = 'SET_GC';
export const UPDATE_GC_AMOUNT = 'UPDATE_GC_AMOUNT';
export const UPDATE_GC_BARBER = 'UPDATE_GC_BARBER';



// WEBPACK FOOTER //
// ./src/app/giftCard/constants.js